module.exports = __webpack_public_path__ + "img/File-csv.c8144aac.svg";